module.exports = __webpack_public_path__ + "static/media/ic-teacher.4656b116.svg";